module.exports = __webpack_public_path__ + "img/user01.06ea2b8a.png";